import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient, HttpParams } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { RestApi } from "src/app/shared/RestApi/restApi";
import { Router } from '@angular/router';
import {catchError, lastValueFrom, map, Observable, throwError} from 'rxjs';
import { error, table } from "console";
import { createCipheriv, createDecipheriv, randomBytes } from 'crypto';

interface commonServiceInfo {
  secretDetails: {};     
  statusMessage: any;
  error: boolean;
  data: any[];
  [Symbol.iterator](): Iterator<any>;
  secretName?: string;
  regionName?: string;

  tables: string[] ;

  accesstoken : any;
  userguideurl: any;
  message:any;
  upload_id:any;
  sql:any;

}
export interface MeddraSearchRequest {
  filterMap: {
    soc_code__v?: string;
    hlgt_code__v?: string;
    hlt_code__v?: string;
    pt_code__v?: string;
    llt_code__v?: string;
  };
  primarySOC: boolean;
  languageOption: string;
  page: number;
  medDRAVersion: string;
  includeNonCurrent: boolean;
  medDRAHierarchyLevel: string;
}


interface etlMigration {
  error: boolean,
  data: any,
  statusMessage:any
}

interface scheduleData {
  statusMessage: any;
  error: boolean;
  data: any;
}

@Injectable({
  providedIn: "root"
})
export class CommonService {
  getPageLayouts() {
    throw new Error('Method not implemented.');
  }

  private headers = new HttpHeaders({
    "Content-Type": "application/json"
    });

    private headerpart = new HttpHeaders({
      'enctype': 'multipart/form-data',  // Ensure the correct encoding
    });

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi,
    private router: Router
  ) { }

  getSchedules(){
    // console.log(this.restAPI.RETRIEVE_SCHEDULE_URL);
    return this.http.get(this.restAPI.RETRIEVE_SCHEDULE_URL);
  }
//seceret="123456$#@$^@1ERF"
  async retrieveService(tableName, recordsStart, tenantid) {

    this.spinner.start();

    console.log(this.restAPI.GET_TABLE_DATA_URL + "/" + tableName + "/" + recordsStart + "/" + 1 + "/" + "a" + "/" + tenantid);

    let response = await this.http.get<commonServiceInfo>(this.restAPI.GET_TABLE_DATA_URL + "/" + tableName + "/" + recordsStart + "/" + 1 + "/" + "a" + "/" + tenantid, { headers: this.headers }).toPromise();

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

  }

  async retrieveDropdownService(tableName, recordsStart, dropDownValuesDisplay, tenantid) {

    this.spinner.start();

    let response = await this.http.get<commonServiceInfo>(this.restAPI.GET_TABLE_DATA_URL + "/" + tableName + "/" + recordsStart + "/" + 0 + "/" + dropDownValuesDisplay + "/" + tenantid, { headers: this.headers }).toPromise();

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

  }

  async insertService(temporaryObject) {

    console.log(temporaryObject);

    this.spinner.start();

    let response = await this.http.post<commonServiceInfo>(this.restAPI.CREATE_RECORD_URL, temporaryObject, { headers: this.headers }).toPromise();

    //Printing the response.
    console.log(response);

    this.spinner.stop();

    this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
    return response.error;

  }

  async updateService(temporaryObject, tableName, idName, idValue) {

    console.log(temporaryObject);

    this.spinner.start();

    let response = await this.http.put<commonServiceInfo>(this.restAPI.UPDATE_RECORD_URL + "/" + tableName + "/" + idName + "/" + idValue, temporaryObject, { headers: this.headers }).toPromise();

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

    }

    else {

      this.spinner.stop();

      console.log(response);

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

    }

    return response.error;

  }

  async deleteService(tableName, idName, idValue) {

    this.spinner.start();

    let response = await this.http.delete<commonServiceInfo>(this.restAPI.DELETE_RECORD_URL + "/" + tableName + "/" + idName + "/" + idValue, { headers: this.headers }).toPromise();

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

    }
    else {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 50000 });
    }

  }
  /*
    @Author:Ravi G
    @Date:28-06-2022
    @Decription delete record from db
*/
  async deleteRecordPermanent(tableName, idName, idValue) {

    this.spinner.start();

   return this.http.delete<commonServiceInfo>(this.restAPI.DELETE_RECORD_PERMANENT_URL + "/" + tableName + "/" + idName + "/" + idValue, { headers: this.headers });



  }
  uploadingExcelFile(sourceFile,dnsName){
    return this.http.post<commonServiceInfo>(this.restAPI.UPLOADCSVFILE+"/"+dnsName,sourceFile);
  }

  public download_test(supportingDoc): Observable<Blob> {

    return this.http.get(supportingDoc, { responseType: 'blob' });

  }

  async downloadImage(supportingDoc) {
    let data = {
      's3Path':supportingDoc,
    };
    let response = await this.http.post(this.restAPI.DOWNLOADFILEFROMS3, JSON.stringify(data),{ headers: this.headers, responseType: 'blob' });
   return  await lastValueFrom(response)



  }
   // Encryption method 
   encrypt(text: string, key: string): string {
    let encryptedText = '';
    const keyLength = key.length;
    for (let i = 0; i < text.length; i++) {
      const charCode = text.charCodeAt(i);
      const keyCharCode = key.charCodeAt(i % keyLength);
      const encryptedCharCode = charCode + keyCharCode;
      encryptedText += String.fromCharCode(encryptedCharCode);
    }
    return encryptedText;
  }
  


  async retrieveSingleRecordService(tableName, fieldName, fieldValue) {
    if(tableName=="users"){
    //  fieldValue=this.encrypt(fieldValue,this.seceret);
    }

    this.spinner.start();

    let response = await this.http.get<commonServiceInfo>(this.restAPI.GET_TABLE_SINGLE_RECORD_URL + "/" + tableName + "/" + fieldName + "/" + fieldValue, { headers: this.headers }).toPromise();
    console.log(response)
    
    if (response.error == true) {
        
      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {
      if(tableName!="users"){
        this.spinner.stop();
      }
      return response;

    }

  }

  async retrieveRecordServiceWithRange(tableName,fromDate,toDate) {
    

    this.spinner.start();
    let pathVariables=tableName+ "/" + fromDate+ "/" + toDate;
    let response = await this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_TABLEDATA_URL + "/" + pathVariables, { headers: this.headers }).toPromise();
    //console.log(tableName);
    console.log(this.restAPI.RETRIEVE_TABLEDATA_URL + "/" + pathVariables);
    console.log(response)

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

  }

    async retrieveRecordServiceWithRangeandCheckBox(tableName,fromDate,toDate,includeSubReport) {
    

    this.spinner.start();
    let pathVariables=tableName+ "/" + fromDate+ "/" + toDate+"/" + includeSubReport;
    let response = await this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_TABLEDATA_URL + "/" + pathVariables, { headers: this.headers }).toPromise();
    //console.log(tableName);
    console.log(this.restAPI.RETRIEVE_TABLEDATA_URL + "/" + pathVariables);
    console.log(response)

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

  }

  async retrieveRecordService(tableName) {
    

    this.spinner.start();

    let response = await this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_TABLEDATA_URL + "/" + tableName, { headers: this.headers }).toPromise();
    //console.log(tableName);
    console.log(response)

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

  }
      /* @added by Ravi G
         @date 18-11-2022
         @desc refresh the vault object attribute
      */
  refereshObjectMetaData(dnsName,objectName){
    console.log(this.restAPI.RETRIEVEOBJECTFIELDSURLBYDNSID + '/' + dnsName+ '/'+objectName)
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVEOBJECTFIELDSURLBYDNSID + '/' + dnsName+ '/'+objectName, {headers: this.headers});

  }

  /* @added by Ravi G
      @date 22-01-2023
      @desc fetch values using multiple where clause
   */
  getlistByMultiplewhereclause(tablename,colNameAndValues) {
    let obj ={
      tableName:tablename,
      colNameAndValues:colNameAndValues
    }

    return this.http.post<commonServiceInfo>(this.restAPI.GETLISTBYMULTIPLEWHERECLAUSE,obj, {headers: this.headers});

  }

   public downloadCsvFileFromS3 (s3Path): Observable<Blob> {
    return this.http.post(this.restAPI.DOWNLOADCSVFILEFROMS3, JSON.stringify(s3Path),{ headers: this.headers, responseType: 'blob' });
  }
  public downloadFileFromS3(s3Path): Observable<Blob> {
    return this.http.post(this.restAPI.DOWNLOADFILEFROMS3, JSON.stringify(s3Path),{ headers: this.headers, responseType: 'blob' });
  }
  /* @added by Ravi G
    @date 15-02-2023
    @desc fetch lookupvalue by lookuptype
 */
  getlookupVauleByLookUpType(lookUpType){
    return this.http.get<commonServiceInfo>(this.restAPI.GETLOOKUPVAULEBYLOOKUPTYPE + '/' + lookUpType, {headers: this.headers});

  }

  getParentReportTemplateDetails() {

    return this.http.get<commonServiceInfo>(this.restAPI.GETPARENTREPORTTEMPLATEDETAILS, {headers: this.headers});

  }

  refreshReportsAndPushToVault(instancedetailid,reruntype,instanceid) {

    return this.http.get<any>(this.restAPI.REEXECUTEGENERATEREPORTPUSHTOVAULT + "/" + instancedetailid+"/"+reruntype+"/"+instanceid, {headers: this.headers});

  }
  
  getVaultSessionId(dnsName){
    return this.http.get<any>(this.restAPI.RETRIEVE_VAULT_SESSIONID+"/"+dnsName,{headers: this.headers});
  }

  
  retrieveRefreshHistory(dnsId){
    return this.http.get<any>(this.restAPI.RETRIEVE_REFRESH_HISTORY+"/"+dnsId,{headers: this.headers})
  }
  retrieveImportExportHistory(dnsId) {
    return this.http.get<any>(this.restAPI.RETRIEVE_IMPORT_EXPORT_HISTORY + "/" + dnsId, { headers: this.headers })
  }


  getRefreshStatus(dnsId){
    return this.http.get<Object>(this.restAPI.RETRIEVE_REFRESH_STATUS+"/"+dnsId,{headers: this.headers})
  }

  retrieveJsuiteRecord(tenantId: number): Promise<any[]> {
    const url = `${this.restAPI.RETRIEVE_JSUITE_PROPERTY}/${tenantId}`;
    return this.http.get<any[]>(url).toPromise();
  }
  insertOneSignalUser(oneSignalDetails){
    return this.http.post<commonServiceInfo>(this.restAPI.INSERT_ONESIGNAL_USER, JSON.stringify(oneSignalDetails),{ headers: this.headers});
  }
  retrieveAboutRecord(): Promise<any[]> {
    const url = `${this.restAPI.RETRIEVE_About_record}`;
    return this.http.get<any[]>(url).toPromise();
  }

  retrieveDnsService(compId): Observable<commonServiceInfo> {
    this.spinner.start();
  

  
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIVE_DNS+"/"+compId, { headers: this.headers }).pipe(
      catchError((error) => {
        console.error("Error:", error);
        this.spinner.stop();
        this.snackBar.open(error.statusMessage, "OK", { duration: 5000 });
        return throwError(error);
      })
    )}

    retrieveDnsUser(dnsId): Observable<commonServiceInfo> {
      this.spinner.start();
      return this.http.get<commonServiceInfo>(this.restAPI.RETRIVE_DNS_USERS+"/"+dnsId, { headers: this.headers }).pipe(
        catchError((error) => {
          console.error("Error:", error);
          this.spinner.stop();
          this.snackBar.open(error.statusMessage, "OK", { duration: 5000 });
          return throwError(error);
        })
      )}

      saveDnsUser(obj) {
     
        return this.http.post<commonServiceInfo>(this.restAPI.SAVE_DNS_USER,obj, {headers: this.headers});
    
      }
      retrieveDnsUserAcessRecord(dnsId): Observable<commonServiceInfo> {
        this.spinner.start();
        return this.http.get<commonServiceInfo>(this.restAPI.RETRIVE_DNS_USER_RECORD+"/"+dnsId, { headers: this.headers }).pipe(
          catchError((error) => {
            console.error("Error:", error);
            this.spinner.stop();
            this.snackBar.open(error.statusMessage, "OK", { duration: 5000 });
            return throwError(error);
          })
        )}
        retrieveLogInUser(userId): Observable<commonServiceInfo> {
          this.spinner.start();
          return this.http.get<commonServiceInfo>(this.restAPI.RETRIVE_LOG_IN_USER+"/"+userId, { headers: this.headers }).pipe(
            catchError((error) => {
              console.error("Error:", error);
              this.spinner.stop();
              this.snackBar.open(error.statusMessage, "OK", { duration: 5000 });
              return throwError(error);
            })
          )}
          deleteRecordAccess(userId): Observable<commonServiceInfo> {
            this.spinner.start();
            return this.http.delete<commonServiceInfo>(this.restAPI.DELETE_RECORD +"/"+userId, { headers: this.headers }).pipe(
              catchError((error) => {
                console.error("Error:", error);
                this.spinner.stop();
                this.snackBar.open(error.statusMessage, "OK", { duration: 5000 });
                return throwError(error);
              })
            )}

          // async deleteRecordAccess(dnsId) {
          //  return this.http.put<commonServiceInfo>(this.restAPI.DELETE_RECORD + "/" + dnsId, { headers: this.headers });
          // }
          downloadFile(data: any, filename:string) {
            const replacer = (key, value) => value === null ? '' : value;
            const header = Object.keys(data[0]);
            let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName],replacer)).join(','));
            csv.unshift(header.join(','));
            let csvArray = csv.join('\r\n');
            var blob = new Blob([csvArray], {type: 'text/csv' })
            // saveAs(blob, filename + ".csv");
            let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none');
                a.href = url;
                a.download = filename+".csv";
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
        }

        retrieveSecret(): Observable<commonServiceInfo> {
          this.spinner.start();
          return this.http.get<commonServiceInfo>(this.restAPI.RETRIVE_SECRET, { headers: this.headers,responseType: 'json' }).pipe(
            catchError((error) => {
              console.error("Error:", error);
              this.spinner.stop();
              this.snackBar.open(error.statusMessage, "OK", { duration: 5000 });
              return throwError(error);
            })
          )}
          saveAwsSecret(obj,dnsid,type):Observable<commonServiceInfo> {
     
            return this.http.post<commonServiceInfo>(this.restAPI.CREATE_SECRET+"/"+dnsid+"/"+type,obj, {headers: this.headers});
        
          }

          searchCase(caseNumber,dnsId){
            return this.http.get<commonServiceInfo>(this.restAPI.searchCase+"/"+caseNumber+"/"+dnsId,{headers: this.headers});
          }

          caseJsonHTML(s3folder,caseid,dnsId,dbName){
            let s3folderobj = {
              s3foldername :s3folder,
              sourceDB : dbName+"_partition_file_path"
            }
            return this.http.post(this.restAPI.CASE_JSON_HTML+"/"+caseid+"/"+dnsId,JSON.stringify(s3folderobj),{ headers: this.headers, responseType: 'text' });
          }


          auditTrailHTML(s3folder,caseid,dnsId,dbName){
            let s3folderobj = {
              s3foldername :s3folder,
              sourceDB : dbName
            }
            return this.http.post(this.restAPI.AUDIT_TRAIL_HTML+"/"+caseid+"/"+dnsId,JSON.stringify(s3folderobj),{ headers: this.headers, responseType: 'text' });
          }
  
          refreshCaseCatalog(dnsId,sourceDb){
            return this.http.get<commonServiceInfo>(this.restAPI.REFRESH_CASE_CATALOG+"/"+dnsId+"/"+sourceDb,{headers: this.headers})
          }
          retrieveS3Path(){
            return this.http.get<scheduleData>(this.restAPI.RETRIEVE_S3_PATH , {headers: this.headers});
        
          }
          buildProject(id){
            return this.http.get<scheduleData>(this.restAPI.BUILD_PROJECT+'/'+id , {headers: this.headers});
        
          }
          public checkoutFiles(body): Observable<Blob> {
            return this.http.post(this.restAPI.CHECKOUT_FILES, JSON.stringify(body),{ headers: this.headers, responseType: 'blob' });

          }
  public retrieveVaultDnsname(envName): any {
    return this.http.get(this.restAPI.RETRIEVE_DNSNAME + "/" + envName,{ headers: this.headers});
  }


  uploadExternalFileToS3(tenantId,formdata){
    return this.http.post<scheduleData>(this.restAPI.UPLOAD_EXTERNALFILE_S3+"/"+tenantId,formdata)
  }

  public downloadLibraryObject(tenantId,fileName): Observable<Blob> {
    return this.http.get(this.restAPI.DOWNLOAD_LIBRARY_OBJECT+"/"+tenantId+"/"+fileName,{ headers: this.headers, responseType: 'blob' });
  }

  retrieveObjectDetectChangesHistory(dnsId){
    return this.http.get<any>(this.restAPI.RETRIEVE_DETECT_OBJECT_CHANGES_HISTORY+"/"+dnsId,{headers: this.headers})
  }

  retrieveVaultObjectChanegs(dnsId,refreshHistoryId){
    return this.http.get<scheduleData>(this.restAPI.RETRIEVE_VAULT_OBJECT_CHANGES + '/' + dnsId+'/'+refreshHistoryId, {headers: this.headers});
  }


   detectChangesObjectMetadata(dnsName){

    return this.http.get<scheduleData>(this.restAPI.DETECT_VAULT_OBJECTS_CHANGES + '/' + dnsName, {headers: this.headers});
  }

  getVaultObjectChangesDetectionStatus(dnsId){
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_VAULT_OBJECT_CHANGES_DETECT_STATUS+"/"+dnsId,{headers: this.headers})
  }

  importVaultChanges(dnsId,changes){
    return this.http.post<commonServiceInfo>(this.restAPI.IMPORT_VAULT_CHANGES+"/"+dnsId,JSON.stringify(changes),{ headers: this.headers})
  }



  async retrieveTestCycleMstr(dnsId: number) {
   const response = await this.http.get<commonServiceInfo>(this.restAPI. GET_TEST_SCRIPTS_FOR_SELECTED_DNS + "/" + dnsId,{ headers: this.headers }).toPromise();
      return response;
  }
//  @author Kameshwar
//  @date 09-10-2024
  ImportDatasets(ObjectgroupId,formdata){
    console.log(formdata.get)
    return this.http.post(this.restAPI.IMPORT_DATASETS+"/"+ObjectgroupId,formdata)
  }
//  @author Kameshwar
//  @date 09-10-2024
  exportDatasets(exportData): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.restAPI.EXPORT_DATASETS, exportData, { headers: headers, responseType: 'blob' });
	
}

retrieveImportHistory(dnsId){
  console.log('Fetching data from API');
  return this.http.get<any>(`${this.restAPI.RETRIEVE_IMPORT_HISTORY}/${dnsId}`, {headers: this.headers});
  }
  retrieveImporExporttHistory(dnsId) {
    console.log('Fetching data from API');
    return this.http.get<any>(`${this.restAPI.RETRIEVE_IMPORT_EXPORT_HISTORY}/${dnsId}`, { headers: this.headers });
  }


  public retrieveDnsServicesforRegionandsecret(dnsId: string) {
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIVE_SECRET_AND_REGION_BASEDON_DNSID + "/" + dnsId,{ headers: this.headers })
  }

  /*
Author:Venkata Shyam 
Date:16-01-2025

*/
  public retrieveAccessTokenForUserGuide():Observable<any>{
    
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_ACCESS_TOKEN, {headers:this.headers})
  }

  insertMappingConfiguration(mapppingData) {
    return this.http.post<commonServiceInfo>(this.restAPI.INSERT_MAPPING_CONFIGURATION, mapppingData, { headers: this.headers });
  }

  retrieveMappingConfiguration(){
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_MAPPING_CONFIGURATION, { headers: this.headers })

  }
  checkIfSourceOrTarget(dataSourceType,names) {
 
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.restAPI.RETIRVE_SOURCE_OR_TARGET+"/"+dataSourceType, names, { headers: headers});
 
  }
  updateMappingConfiguration(mapppingData) {
    return this.http.post<commonServiceInfo>(this.restAPI.UPDATE_MAPPING_CONFIGURATION, mapppingData, { headers: this.headers });
  }
  deleteMappingConfiguration(id) {
    return this.http.delete<commonServiceInfo>(this.restAPI.DELETE_MAPPING_CONFIGURATION + "/" + id, { headers: this.headers })
  
  }
  canDeleteOrModify(id) {
    return this.http.delete<commonServiceInfo>(this.restAPI.CAN_MODIFY_OR_DELETE + "/" + id, { headers: this.headers })

  }

public getTenantidBasedOnEnvName(envName): any {
  return this.http.get(this.restAPI.RETRIEVE_DNS_ID_BASED_ON_ENV_NAME + "/" + envName,{ headers: this.headers});
}
 
retrieveSourceDnsWithDetails(userid): Observable<any> {
 
  return this.http.get<any>(this.restAPI.RETRIEVE_DNS_BASED_USER+"/"+userid,{headers:this.headers});
}
  
  public getTableDataByDns(tableName,dnsName):Observable<any>{
    
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_DETAILS_OF_SCREEN_BASED_DNSNAME+ '/' + tableName + '/'+dnsName,{headers:this.headers})
  }

  public getTenantidBasedOnName(dnsName){
   
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVEDNSID + '/'+dnsName,{headers:this.headers})
  }
  public getTenantidBasedEnvname(envname){
   
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVEDNSID_BASED_ON_ENVNAME + '/'+envname,{headers:this.headers})
  }

  retrieveObjectGroupObjectsbasedDns(dnsid): Observable<any>{
    
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_GROUP_OBJECTS_BASED_DNS+"/"+dnsid,{ headers: this.headers });
  }

  
  checkIfSource(names) {
       const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.restAPI.RETIRVE_SOURCE_OR_NOT, names, { headers: headers});
	
}
  

  retrieverecordsForPurge():Observable<any>{
    return this.http.get<string[]>(this.restAPI.RETRIEVE_RECORDS_FOR_PURGING ,{headers:this.headers})
  }

  savePurgeData(purgeDataDTO): Observable<any> {
    return this.http.post<any>(this.restAPI.SAVE_PURGE_DATA,purgeDataDTO, {headers:this.headers})
  }

  retrieverecordsOfPurge(dnsId):Observable<any>{
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_PURGE_RECORDS + "/" + dnsId,{headers:this.headers})
  }

  selectedGroupName(groupname){
    return this.http.get<any>(this.restAPI.RETRIEVE_TABLE_RECORDS + "/" + groupname,{headers:this.headers})
  }

  deletePurge(purgeid) {
    return this.http.get<commonServiceInfo>(this.restAPI.DELETE_PURGE_RECORD + "/" + purgeid, {headers : new HttpHeaders({ 'Content-Type': 'plain/text' })})
  }

 
uploadingMappingFile(sourceFile:FormData){
  return this.http.post<commonServiceInfo>(this.restAPI.UPLOAD_MAPPING_EXCEL_FILE,sourceFile,{headers: this.headerpart});
}
 
retrieveFunctionalMapping(formDataforretrieve:FormData) {
 
  return this.http.post<commonServiceInfo>(this.restAPI.RETRIEVE_FUNCTIONAL_MAPPING ,formDataforretrieve, { headers: this.headerpart });
 
}
 
editFunctionalMapping(uploadId, updatedata) {
  const payload = {
    uploadId: uploadId,
    data: updatedata
  };
 
  return this.http.post<commonServiceInfo>(this.restAPI.EDIT_FUNCTIONAL_MAPPING,payload,{ headers: this.headerpart });
 
}

generateCIOMSandMedWatchReport(formData){
  return this.http.post<commonServiceInfo>(this.restAPI.generateCompareReport,formData,{ headers: this.headerpart })
}

retrieveAllReport(dnsId){
  return this.http.get<commonServiceInfo>(this.restAPI.retrieveAllReports+'/'+dnsId,{ headers: this.headerpart })
}

existingReportNames(dnsId){
  return this.http.get<commonServiceInfo>(this.restAPI.retrieveAllReports+'/'+dnsId,{ headers: this.headerpart })

}
// downloadMappingFile(migrationId) : Observable<Blob> {
//   return this.http.get(this.restApi.DOWNLOADMAPPINGFILE+"/"+migrationId, { headers: this.headers,  responseType: 'blob' });
// }


downloadReport(reportId,type) : Observable<Blob>{
  return this.http.get(this.restAPI.downloadCiomReport+"/"+reportId+"/"+type,{ headers: this.headers,  responseType: 'blob' })
}

retrieveMappingTypesByTenantId(tenantId):Observable<any>{
  return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_MAPPING_TYPES+"/"+tenantId,{headers:this.headers})
}


saveMappingtype(mappintypeName){
  return this.http.post<commonServiceInfo>(this.restAPI.SAVE_MAPPING_TYPE,mappintypeName,{ headers: this.headerpart })
}

deleteMappingtype(mappingTypeId):Observable<any>{
  return this.http.get<commonServiceInfo>(this.restAPI.DELETE_MAPPING_TYPES+"/"+mappingTypeId,{headers:this.headers})
}


retrieveDnsInfo(workspaceId):Observable<any>{
  return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVES_DNS_INFO+"/"+workspaceId,{headers:this.headers})
}
copyObjectsFromSourceToTarget(selectedRows):Observable<any>{
  return this.http.post<commonServiceInfo>(this.restAPI.COPYDATAFROMSOURCETOTARGET,selectedRows)
}
 getVaultSession(dnsName){
    return this.http.get<any>(this.restAPI.RETRIEVE_VAULT_SESSION+"/"+dnsName,{headers: this.headers});
  }

getPRR(pairs: Array<{ drug: string; event: string }>) {
    return this.http.post<Array<any>>(this.restAPI.GET_PRR, pairs, {
      headers: this.headers
    });
  }



  searchDrugs(query: string, limit = 100): Observable<string[]> {
    const params = new HttpParams()
      .set('q', query)
      .set('size', limit.toString());
    return this.http.get<string[]>(
      this.restAPI.GET_ALL_DRUGS,
      { params }
    );
  }

  searchEvents(drug: string,query: string, limit = 100): Observable<string[]> {
    const params = new HttpParams()
      .set('drug', drug)
      .set('q', query)
      .set('size', limit.toString());
    return this.http.get<string[]>(
      this.restAPI.GET_ALL_ADE,
      { params }
    );
  }


  public getDataByDns(dnsName):Observable<any>{
    
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_DETAILS_BASED_ON_DNSNAME+ '/'+dnsName,{headers:this.headers})
  }

  retrieveNonStageObjectsbasedDns(dnsid): Observable<any>{
    
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_NON_STAGE_OBJECTS_BASED_DNS+"/"+dnsid,{ headers: this.headers });
  }

  getSqlForBussinesslogic(sourceAttribute,targetattribute,sourceSelectedAttribute,targetSelectedAttribute,text): Observable<any>{
     const payload = {
    sourceAttributes: sourceAttribute,
    targetAttributes: targetattribute,
    selecedSourceAttribute:sourceSelectedAttribute,
    selecedTargetAttribute:targetSelectedAttribute,
    logic: text
  };
      return this.http.post<commonServiceInfo>(this.restAPI.RETRIEVE_SQl_BASED_ON_BUSSINESS_LOGIC,payload,{ headers: this.headers });
  }


  insertPasswordPolicies(passwordPolicy){
    return this.http.post<commonServiceInfo>(this.restAPI.INSERT_PASSWORD_POLICY,passwordPolicy,{headers: this.headers})
  }

  retrieveDetails(){
    return this.http.get<any>(this.restAPI.RETRIEVE_PASSWORD_POLICIES,{headers:this.headers})
  }

  deletePasswordPolicies(id){
    return this.http.get<commonServiceInfo>(this.restAPI.DELETE_PASSWORD_POLICIES +"/"+id,{headers:this.headers})
  }

   getObjectsWithObjectGroup(tenantId,objectGroupName,sourceTenantId){
    // let dnsId = this.localStorageSettings.getSettings("dnsName");
    return this.http.get<any>(this.restAPI.GET_OBJECTS_WITH_OBJECTGROUP + "/" + tenantId+ "/" +objectGroupName+"/"+sourceTenantId, { headers: this.headers })
  }

  retrieveObjectsBasedOnObjectGroupNamebasedDns(tenantId,objectGroupName,sourceTenantId): Observable<any>{
    
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_OBJECTS_ON_OBJECT_GROUP+"/"+tenantId+"/"+objectGroupName+"/"+sourceTenantId,{ headers: this.headers });
  }
  retrieveObjectsBasedOnObjectGroupId(objectGroupId): Observable<any>{
    
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_OBJECTS_ON_OBJECT_GROUP_ID+"/"+objectGroupId,{ headers: this.headers });
  }
uploadMappingFile(mappingFile: any, dnsName: string, file: File) {
    const formData = new FormData();

    // ✅ Append the original File object directly
    formData.append('file', file, file.name);

    // Append the 'data' part as JSON
    formData.append('data', JSON.stringify(mappingFile));

    return this.http.post<etlMigration>(this.restAPI.UPLOADSNAPSHOT + "/" + dnsName, formData);
  }
  

  async downloadJsonFile(tableName: string, tenantIdValue: string): Promise<Blob> {
    const url = this.restAPI.EXPORT_JSON + `/${tableName}/${tenantIdValue}`;
    const response = this.http.get(url, { headers: this.headers, responseType: 'blob' });
    return await lastValueFrom(response);
  }
  async downloadzipFile(snapshotid: string, tenantIdValue: string,importType:string): Promise<Blob> {
    const url = this.restAPI.EXPORT_SNAPSHOT_ZIP + `/${tenantIdValue}/${snapshotid}/${importType}`;
    const response = this.http.get(url, { headers: this.headers, responseType: 'blob' });
    return await lastValueFrom(response);
  }
  importJsonFile(tableName: string, tenantId: string, file: File,workspaceId: string) {
    const formData = new FormData();
    formData.append('tenantId', tenantId);
    formData.append('file', file);
    formData.append('workSpaceId',workspaceId)

    return this.http.post(`${this.restAPI.IMPORT_JSON}/${tableName}` + "/" + tenantId + "/" + workspaceId, formData);
  }
  importZipFile(tenantId: string, file: File , importType: string) {
    const formData = new FormData();
    formData.append('tenantId', tenantId);
    formData.append('file', file);

    return this.http.post(`${this.restAPI.IMPORT_SNAPSHOT_ZIP}` + "/" + tenantId + "/" + importType, formData);
  }
  
  
  retrieveSourceExtractionQueriesByTenantId(tenantId) :Observable<any>{
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_SOURCE_EXTRACTION_QUERIES + "/"+ tenantId,{headers: this.headers})

  }
  saveSourceDataExtractionQueries(data){
    return this.http.post<commonServiceInfo>(this.restAPI.INSERT_SOURCE_DATA_EXTRACTION_QUERIES,data,{headers: this.headers})
  }

  deleteSourceExtractionQueries(recordId){
     return this.http.get<commonServiceInfo>(this.restAPI.DELETE_SOURCE_EXTRACTION_QUERIESS + '/'+recordId,{headers: this.headers})

  }

  getDataSourceName(workSpaceId){
     return this.http.get<commonServiceInfo>(this.restAPI.DATASOURCENAMES + '/'+workSpaceId,{headers: this.headers})
  }

   retrieveObjectsBasedOnObjectGroupNameBasedOnTenantId(tenantId,objectGroupName): Observable<any>{
    
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_OBJECTS_ON_OBJECT_GROUP_TENANTID+"/"+tenantId+"/"+objectGroupName,{ headers: this.headers });
  }

  getHelpLink(hyperDto): Observable<string> {
  return this.http.post(this.restAPI.GET_HELP_LINK, JSON.stringify(hyperDto), {
    headers: this.headers,
    responseType: "text",
  });
}


retrieveExceptionByTenantId(tenantId):Observable<any>{
  return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_Exception_Queries+"/"+tenantId,{headers:this.headers})
}

createOrUpdateExceptionQuery(dto: any): Observable<any> {
  return this.http.post<any>(this.restAPI.INSERT_Exception_Queries, dto, { headers: this.headers });
}

deleteExceptionQueryById(id){
 return this.http.delete<commonServiceInfo>(this.restAPI.DELETE_Exception_Queries.replace("{id}", id),{ headers: this.headers });
}


//added by kameshwar.d
/**
 * Get available MedDRA versions
 */
getAvailableVersions(): Observable<string[]> {
  return this.http.get<string[]>(this.restAPI.getMedraVersions, { 
    headers: this.headers 
  });
}


/**
 * SINGLE METHOD for all MedDRA data operations
 * - Get SOCs, HLGTs, HLTs, PTs, LLTs
 * - Get records for right table
 */
getMeddraData(request: MeddraSearchRequest): Observable<any> {
  return this.http.post<any>(this.restAPI.getMedradata, request, { 
    headers: this.headers 
  });
}
getjsuiteCategory(category){
  const url = this.restAPI.RETRIEVE_JSUITE_CATEGORY.replace('{lookupType}', category);
     return this.http.get<commonServiceInfo>(url,{headers: this.headers})
  }
  getjsuitePropertyByCategory(category){
  const url = this.restAPI.RETRIEVE_JSUITE_PROPERTIES.replace('{lookupValue}', category);
     return this.http.get<commonServiceInfo>(url,{headers: this.headers})
  }
  getComponentType(dnsname){
  const url = this.restAPI.RETRIEVE_COMPONENT_TYPE.replace('{dnsName}', dnsname);
     return this.http.get<commonServiceInfo>(url,{headers: this.headers})
  }
  saveManageMdlScript(data){
    return this.http.post<commonServiceInfo>(this.restAPI.INSERT_MANAGE_MDL_SCRIPT,data,{headers: this.headers})
  }
   retrieveManageMdlScript() :Observable<any>{
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_MANAGE_MDL_SCRIPT,{headers: this.headers})

  }
  deleteMdlScript(manageMDLScriptId){
      const url = this.restAPI.DELETE_MANAGE_MDL_SCRIPT.replace('{status}', "No").replace('{manageMDLScriptId}',manageMDLScriptId);
      return this.http.put<commonServiceInfo>(url,{headers: this.headers})

  }
  executeMdlScript(dnsname,script,id){
  const url = this.restAPI.EXECUTE_MDL_SCRIPT.replace('{dnsName}', dnsname).replace('{id}',id);
     return this.http.post<commonServiceInfo>(url,script,{headers: this.headers})
  }
  updateJsuiteProperties(data){
  const url = this.restAPI.UPDATE_JSUITE_PROPERTIES;
     return this.http.post<commonServiceInfo>(url,data,{headers: this.headers})
  }

getMigrationType(migrationId){
  return this.http.get(this.restAPI.GET_MIGRATION_TYPE + migrationId, {
    headers: this.headers,
    responseType: 'text'
  });
}


 retrieveSourceTargetObjects(){
    return this.http.get<any[]>(this.restAPI.RETRIEVE_MAPPING_CONFIGURATION_OBJECTS, { headers: this.headers })

  }

  retrieveMappedAttributes(mappingIds: number[]) {

  let params = new HttpParams();
  mappingIds.forEach(id => {
    params = params.append('mappingObjectIds', id.toString());
  });

  return this.http.get<any[]>(
    this.restAPI.RETRIEVE_MAPPED_ATTRIBUTES,
    { params, headers: this.headers }
  );
}

 retrieveCompletedLoadsets(){
    return this.http.get<any[]>(this.restAPI.RETRIEVE_COMPLETED_LOADSETS, { headers: this.headers })
  }

  saveRemigrateMappingAndObjects(payload: any){
    return this.http.post<any[]>(this.restAPI.SAVE_REMIGRATE_MAPPING_AND_OBJECTS,payload,{ headers: this.headers });
}

  getObjectPageLayouts() {
  return this.http.get<any>(
    this.restAPI.OBJECT_PAGE_LAYOUTS
  );
}

 retrieveLoadObjectsFromLoadObjectsmstr(dnsId) :Observable<any>{
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_LOAD_OBJECTS_MSTR + "/"+ dnsId,{headers: this.headers})

  }

  saveLoadObjectsMstr(data){
    return this.http.post<commonServiceInfo>(this.restAPI.INSERT_LOAD_OBJECTS_MSTR,data,{headers: this.headers})
  }

  deleteLoadObjectsMstr(recordId){
     return this.http.get<commonServiceInfo>(this.restAPI.DELETE_LOAD_OBJECTS_MSTR + '/'+recordId,{headers: this.headers})

  }


getSelfReferenceFiles(tenantId: number, level: number) {
  return this.http.get<
    { fileName: string; mappingconfigurationid: number }[]
  >(
    `${this.restAPI.RETRIEVE_SELF_REFERENCE_FILENAMES}/${tenantId}/${level}`,
    { headers: this.headers }
  );
}


getTargetAttributesByMappingConfigId(mappingconfigurationid: number) {
  return this.http.get<{ name: string }[]>(
    `${this.restAPI.GET_TARGET_ATTRIBUTES}/${mappingconfigurationid}`,
    { headers: this.headers }
  );
}


getAllJeevObjects(){
  return this.http.get<any>(this.restAPI.RETRIEVE_JEEV_OBJECTS);
}

refreshAllJeevObjects(){
  return this.http.post<any>(this.restAPI.REFRESH_JEEV_OBJECTS, {});
}

getJeevObjectsRefreshHistory(){
  return this.http.get<any>(this.restAPI.JEEV_OBJECTS_REFRESH_HISTORY);
}

createJeevObject(data: any) {
   return this.http.post<any>(this.restAPI.CREATE_JEEV_OBJECTS, data);
}


deleteJeevObject(objectId: number) {
  return this.http.delete<any>(this.restAPI.DELETE_JEEV_OBJECTS + "/" + objectId);
}

getAllLifecycle(){
  return this.http.get<any>(this.restAPI.RETRIEVE_LIFECYCLE);
}

refreshSingleJeevObject(objectName){
  return this.http.post(this.restAPI.REFRESH_SINGLE_JEEV_OBJECT + "/" + objectName, {});
}

getJeevObjectRefreshStatus(){
  return this.http.get(
    this.restAPI.JEEV_OBJECT_REFRESH_STATUS
  );
}

getAttributeTypes(){
  return this.http.get<any>(this.restAPI.ATTRIBUTE_TYPES);
}

getObjectAttributes(objectName: string,tenantId: string,type:String) {
  return this.http.get<any>(
    this.restAPI.GET_OBJECT_ATTRIBUTES + "/" + objectName+ "/"+tenantId+"/"+type,
    { headers: this.headers }
  );
}

getObjectNames(tenantId: string) {
  return this.http.get(
    this.restAPI.GET_OBJECT_NAMES + "/" + tenantId,
    { headers: this.headers }
  );
}

getObjectLabel(objectname: string, tenantid: number) {
  return this.http.get(
    this.restAPI.GET_OBJECT_LABEL + `?objectname=${objectname}&tenantid=${tenantid}`,
    { responseType: 'text' }   
  );
}


  retrieveObjectsByDNSExcludingStage(dnsid): Observable<any>{
    
    return this.http.get<commonServiceInfo>(this.restAPI.RETRIEVE_GROUP_OBJECTS_BASED_DNS_EXCLUDING_STAGE+"/"+dnsid,{ headers: this.headers });
  }
getObjectGroupIdByName(name: string, tenantId: number): Observable<number> {
  return this.http.get<number>(
    this.restAPI.GET_OBJECT_GROUP_ID_BY_NAME + "/" + name + "/" + tenantId,{ headers: this.headers }
  );
}


// services for Jtest 3 new screens 1. computerized library , release Library , requirement library 

//computerized System Library 

/**
 * Get all Computerized System Library records by workspace
 */
getAllComputerizedSystemLibrary(workspaceId: number): Observable<any> {
  return this.http.get<any>(
    this.restAPI.GET_ALL_COMPUTERIZED_SYSTEM_LIBRARY + "/" + workspaceId,
    { headers: this.headers }
  );
}

/**
 * Get Computerized System Library by Id
 */
getComputerizedSystemLibraryById(id: number): Observable<any> {
  return this.http.get<any>(
    this.restAPI.GET_COMPUTERIZED_SYSTEM_LIBRARY_BY_ID + "/" + id,
    { headers: this.headers }
  );
}

/**
 * Create Computerized System Library
 */
createComputerizedSystemLibrary(data: any): Observable<any> {
  return this.http.post<any>(
    this.restAPI.CREATE_COMPUTERIZED_SYSTEM_LIBRARY,
    data,
    { headers: this.headers }
  );
}

/**
 * Update Computerized System Library
 */
updateComputerizedSystemLibrary(id: number, data: any): Observable<any> {
  return this.http.put<any>(
    this.restAPI.UPDATE_COMPUTERIZED_SYSTEM_LIBRARY + "/" + id,
    data,
    { headers: this.headers }
  );
}

/**
 * Delete Computerized System Library
 */
deleteComputerizedSystemLibrary(id: number): Observable<any> {
  return this.http.delete<any>(
    this.restAPI.DELETE_COMPUTERIZED_SYSTEM_LIBRARY + "/" + id,
    { headers: this.headers }
  );
}

/**
 * Update Computerized System Library Status
 */
updateComputerizedSystemLibraryStatus(id: number, status: string): Observable<any> {
  return this.http.put<any>(
    this.restAPI.UPDATE_COMPUTERIZED_SYSTEM_LIBRARY_STATUS +
      "/" + id + "/status/" + status,
    {},
    { headers: this.headers }
  );
}

//release library 

getAllReleaseLibrary(workspaceId: number): Observable<any> {
  return this.http.get<any>(
    this.restAPI.GET_ALL_RELEASE_LIBRARY + "/" + workspaceId,
    { headers: this.headers }
  );
}

getReleaseLibraryById(id: number): Observable<any> {
  return this.http.get<any>(
    this.restAPI.GET_RELEASE_LIBRARY_BY_ID + "/" + id,
    { headers: this.headers }
  );
}

createReleaseLibrary(data: any): Observable<any> {
  return this.http.post<any>(
    this.restAPI.CREATE_RELEASE_LIBRARY,
    data,
    { headers: this.headers }
  );
}


updateReleaseLibrary(id: number, data: any): Observable<any> {
  return this.http.put<any>(
    this.restAPI.UPDATE_RELEASE_LIBRARY + "/" + id,
    data,
    { headers: this.headers }
  );
}

deleteReleaseLibrary(id: number): Observable<any> {
  return this.http.delete<any>(
    this.restAPI.DELETE_RELEASE_LIBRARY + "/" + id,
    { headers: this.headers }
  );
}

updateReleaseLibraryStatus(id: number, status: string): Observable<any> {
  return this.http.put<any>(
    this.restAPI.UPDATE_RELEASE_LIBRARY_STATUS +
      "/" + id + "/status/" + status,
    {},
    { headers: this.headers }
  );
}


// Requirement Library 

getRequirementLibraries(workspaceId: number): Observable<any> {
  return this.http.get<any>(
    this.restAPI.GET_REQUIREMENTS_LIBRARY + "/" + workspaceId,
    { headers: this.headers }
  );
}

getRequirementLibrary(id: number): Observable<any> {
  return this.http.get<any>(
    this.restAPI.REQUIREMENTS_LIBRARY + "/" + id,
    { headers: this.headers }
  );
}

createRequirementLibrary(data: any): Observable<any> {
  return this.http.post<any>(
    this.restAPI.CREATE_REQUIREMENTS_LIBRARY,
    data,
    { headers: this.headers }
  );
}


updateRequirementLibrary(id: number, data: any): Observable<any> {
  return this.http.put<any>(
    this.restAPI.UPDATE_REQUIREMENTS_LIBRARY + "/" + id,
    data,
    { headers: this.headers }
  );
}

deleteRequirementLibrary(id: number): Observable<any> {
  return this.http.delete<any>(
    this.restAPI.DELETE_REQUIREMENTS_LIBRARY + "/" + id,
    { headers: this.headers }
  );
}

updateRequirementLibraryStatus(
  id: number,
  status: string
): Observable<any> {
  return this.http.put<any>(
    this.restAPI.UPDATE_REQUIREMENTS_LIBRARY_STATUS +
      "/" +
      id +
      "/status/" +
      status,
    {},
    { headers: this.headers }
  );
}

calculateRiskRating(data: any): Observable<any> {
  return this.http.post<any>(
    this.restAPI.REQUIREMENTS_LIBRARY_RISK_RATING,
    data,
    { headers: this.headers }
  );
}

getRequirementLibraryInfo(workspaceId: number): Observable<any> {
  return this.http.get<any>(
    this.restAPI.REQUIREMENTS_LIBRARY_INFO + "/" + workspaceId,
    { headers: this.headers }
  );
}

getReleaseAndModuleBySystem(
  workspaceId: number,
  systemId: number
): Observable<any> {
  return this.http.get<any>(
    `${this.restAPI.REQUIREMENTS_LIBRARY_RELEASE_MODULE}/workspace/${workspaceId}/system/${systemId}`,
    { headers: this.headers }
  );
}


getCurrentSourceCsvPath() {
  return this.http.get<any>(
    this.restAPI.GET_CURRENT_SOURCE_CSV
  );
}

}
